class ReferencesAPI {
  static all(state) {
    const { count, offset, language } = state
    let url = `/${language}/wp-json/wp/v2/references?per_page=${count}&offset=${offset}&status=publish`

    return fetch(url, {
      credentials: 'same-origin'
    }).then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }
}

export default ReferencesAPI



// WEBPACK FOOTER //
// ./src/js/references/api/ReferencesAPI.js